import { render, staticRenderFns } from "./MutableInputContainer.vue?vue&type=template&id=2fbb63ca"
import script from "./MutableInputContainer.vue?vue&type=script&lang=ts"
export * from "./MutableInputContainer.vue?vue&type=script&lang=ts"
import style0 from "./MutableInputContainer.vue?vue&type=style&index=0&id=2fbb63ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports